import React, { useState } from 'react'
import PageHeader from './Shared/PageHeader'

const stats = [
  { value: '3+', label: 'Years Exp.', color: '#facc15', rgb: '250,204,21' },
  { value: '20+', label: 'Projects', color: '#818cf8', rgb: '129,140,248' },
  { value: '10+', label: 'Tech Stack', color: '#34d399', rgb: '52,211,153' },
  { value: '∞', label: 'Keep Learning', color: '#c084fc', rgb: '192,132,252' }
]

const tags = [
  { label: 'React.js', color: '#61DAFB', rgb: '97,218,251' },
  { label: 'Next.js', color: '#e2e8f0', rgb: '226,232,240' },
  { label: 'TypeScript', color: '#60a5fa', rgb: '96,165,250' },
  { label: 'Node.js', color: '#4ade80', rgb: '74,222,128' },
  { label: 'Express.js', color: '#f87171', rgb: '248,113,113' },
  { label: 'PostgreSQL', color: '#7dd3fc', rgb: '125,211,252' },
  { label: 'Sequelize', color: '#38bdf8', rgb: '56,189,248' },
  { label: 'MongoDB', color: '#4ade80', rgb: '74,222,128' },
  { label: 'Redis', color: '#f87171', rgb: '248,113,113' },
  { label: 'Tailwind CSS', color: '#22d3ee', rgb: '34,211,238' },
  { label: 'Shopify', color: '#a3e635', rgb: '163,230,53' },
  { label: 'REST API', color: '#a78bfa', rgb: '167,139,250' },
  {
    label: 'GraphQL',
    color: '#e879f9',
    rgb: '232,121,249'
  },

  { label: 'Claude AI', color: '#fb923c', rgb: '251,146,60' },
  { label: 'Cursor', color: '#fbbf24', rgb: '251,191,36' }
]

const StatCard = ({ value, label, color, rgb }) => {
  const [hovered, setHovered] = useState(false)
  return (
    <div
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        padding: '20px 12px 16px',
        borderRadius: '14px',
        border: `1px solid rgba(${rgb},${hovered ? '0.45' : '0.2'})`,
        background: hovered
          ? `linear-gradient(145deg, rgba(${rgb},0.14), rgba(${rgb},0.04))`
          : `linear-gradient(145deg, rgba(${rgb},0.08), rgba(${rgb},0.02))`,
        textAlign: 'center',
        position: 'relative',
        overflow: 'hidden',
        transform: hovered
          ? 'translateY(-5px) scale(1.03)'
          : 'translateY(0) scale(1)',
        boxShadow: hovered
          ? `0 0 28px rgba(${rgb},0.22), 0 8px 24px rgba(0,0,0,0.35), inset 0 1px 0 rgba(255,255,255,0.06)`
          : `0 0 12px rgba(${rgb},0.1), inset 0 1px 0 rgba(255,255,255,0.04)`,
        transition: 'all 0.28s cubic-bezier(0.34,1.56,0.64,1)'
      }}>
      {/* top color bar */}
      <div
        style={{
          position: 'absolute',
          top: 0,
          left: '20%',
          right: '20%',
          height: '2px',
          background: `linear-gradient(90deg, transparent, ${color}, transparent)`,
          boxShadow: `0 0 8px rgba(${rgb},0.7)`,
          borderRadius: '2px'
        }}
      />

      <p
        style={{
          fontSize: '2rem',
          fontWeight: 900,
          color,
          textShadow: `0 0 20px rgba(${rgb},0.6), 0 0 40px rgba(${rgb},0.2)`,
          margin: 0,
          lineHeight: 1,
          letterSpacing: '-0.03em'
        }}>
        {value}
      </p>
      <p
        style={{
          fontSize: '10px',
          fontWeight: 600,
          color: `rgba(${rgb},0.65)`,
          letterSpacing: '0.12em',
          textTransform: 'uppercase',
          margin: '8px 0 0'
        }}>
        {label}
      </p>
    </div>
  )
}

const Tag = ({ label, color, rgb }) => {
  const [hovered, setHovered] = useState(false)
  return (
    <span
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '6px',
        padding: '5px 13px',
        borderRadius: '20px',
        fontSize: '11px',
        fontWeight: 600,
        letterSpacing: '0.05em',
        border: `1px solid rgba(${rgb},${hovered ? '0.5' : '0.22'})`,
        color: hovered ? color : `rgba(${rgb},0.7)`,
        background: hovered ? `rgba(${rgb},0.12)` : `rgba(${rgb},0.05)`,
        boxShadow: hovered ? `0 0 12px rgba(${rgb},0.25)` : 'none',
        transform: hovered ? 'translateY(-2px)' : 'none',
        transition: 'all 0.2s ease',
        textShadow: hovered ? `0 0 8px rgba(${rgb},0.4)` : 'none'
      }}>
      <span
        style={{
          width: '5px',
          height: '5px',
          borderRadius: '50%',
          background: color,
          boxShadow: `0 0 6px rgba(${rgb},0.8)`,
          flexShrink: 0
        }}
      />
      {label}
    </span>
  )
}

const Highlight = ({ children }) => (
  <span
    style={{
      color: '#facc15',
      fontWeight: 600,
      textShadow: '0 0 8px rgba(250,204,21,0.3)'
    }}>
    {children}
  </span>
)

const About = () => (
  <div>
    <PageHeader title='About' />

    {/* stats */}
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(4, 1fr)',
        gap: '12px',
        margin: '28px 0 32px'
      }}>
      {stats.map((s) => (
        <StatCard key={s.label} {...s} />
      ))}
    </div>

    <div
      style={{
        height: '1px',
        marginBottom: '28px',
        background:
          'linear-gradient(90deg, rgba(250,204,21,0.2), rgba(129,140,248,0.15), transparent)'
      }}
    />

    <h2
      style={{
        color: '#f1f5f9',
        fontSize: '1.4rem',
        fontWeight: 700,
        marginBottom: '16px',
        letterSpacing: '-0.01em'
      }}>
      Hi, I'm Shakib 👋
    </h2>

    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '14px',
        width: '92%'
      }}>
      <p
        style={{
          color: '#9ca3af',
          lineHeight: 1.8,
          fontSize: '14px',
          margin: 0
        }}>
        I'm a <Highlight>full-stack developer</Highlight> with{' '}
        <Highlight>3+ years of experience</Highlight> building scalable web
        applications across both frontend and backend. I specialize in{' '}
        <Highlight>JavaScript technologies</Highlight> including React.js and
        Node.js, and have hands-on experience developing{' '}
        <Highlight>Shopify-based systems</Highlight>, APIs, and production-ready
        applications. Recently, I worked on building an{' '}
        <Highlight>A/B testing platform</Highlight> to improve user experience
        and conversion performance.
      </p>
      <p
        style={{
          color: '#9ca3af',
          lineHeight: 1.8,
          fontSize: '14px',
          margin: 0
        }}>
        I actively use <Highlight>AI-assisted development tools</Highlight> such
        as Claude and Cursor to enhance productivity, improve code quality, and
        accelerate development workflows. I enjoy solving real-world problems
        and delivering reliable solutions. I write{' '}
        <Highlight>clean, maintainable code</Highlight> that creates real
        impact.
      </p>
    </div>

    <div
      style={{
        height: '1px',
        margin: '28px 0 20px',
        background:
          'linear-gradient(90deg, rgba(52,211,153,0.2), rgba(192,132,252,0.15), transparent)'
      }}
    />

    <p
      style={{
        color: '#4b5563',
        fontSize: '10px',
        fontWeight: 700,
        letterSpacing: '0.14em',
        textTransform: 'uppercase',
        marginBottom: '14px'
      }}>
      Currently Working With
    </p>
    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
      {tags.map((t) => (
        <Tag key={t.label} {...t} />
      ))}
    </div>
  </div>
)

export default About
